import types from './types';

export const open = target => {
    return {
        type: types.open,
        payload: target
    }
}

export const close = () => {
    return {
        type: types.close
    }
}